import React from 'react';
import { Typography } from '@mui/material';
import { PayPeriodTableMenu } from './PayPeriodTableMenu';

const columns = [
  {
    fieldName: 'id',
    name: 'i',
    label: 'Id',
    type: 'number',
    formatValue: ({ row, column }) => {
      return <Typography variant="body2">{row[column.fieldName]}</Typography>;
    },
  },
  {
    fieldName: 'payPeriodStartDate',
    name: 'dn',
    label: 'Start Date',
    type: 'string',
    formatValue: ({ row, column }) => <Typography variant="body2">{row[column.fieldName]}</Typography>,
  },
  {
    fieldName: 'payPeriodEndDate',
    name: 'pt',
    label: 'End date',
    type: 'string',
    formatValue: ({ row, column }) => <Typography variant="body2">{row[column.fieldName]}</Typography>,
  },
  {
    fieldName: 'attendanceInputsCutoffDate',
    name: 'el',
    label: 'Attendance Inputs Cutoff Date',
    type: 'string',
    formatValue: ({ row, column }) => <Typography variant="body2">{row[column.fieldName]}</Typography>,
  },
  {
    fieldName: 'payChangesCutOffDate',
    name: 'et',
    label: 'Pay Changes Cutoff Date',
    type: 'string',
    formatValue: ({ row, column }) => <Typography variant="body2">{row[column.fieldName]}</Typography>,
  },
  {
    fieldName: 'payRunDate',
    name: 'cr',
    label: 'Payrun Date',
    type: 'string',
    formatValue: ({ row, column }) => <Typography variant="body2">{row[column.fieldName]}</Typography>,
  },
  {
    fieldName: 'payRunFinalApprovalDate',
    name: 'me',
    label: 'PayRun Final Approval Date',
    type: 'number',
    formatValue: ({ row, column }) => <Typography variant="body2">{row[column.fieldName]}</Typography>,
  },
  {
    fieldName: 'lockStatus',
    name: 'cm',
    label: 'Lock Status',
    type: 'string',
    formatValue: ({ row, column }) => <Typography variant="body2">{row[column.fieldName]}</Typography>,
  },
  {
    fieldName: 'payDate',
    name: 'fps',
    label: 'Pay Date',
    type: 'string',
    formatValue: ({ row, column }) => <Typography variant="body2">{row[column.fieldName]}</Typography>,
  },
  {
    fieldName: 'processState',
    name: 'fps',
    label: 'Process State',
    type: 'string',
    formatValue: ({ row, column }) => <Typography variant="body2">{row[column.fieldName]}</Typography>,
  },
  {
    fieldName: 'action',
    name: 'action',
    label: 'Actions',
    sticky: true,
    filter: true,
    formatValue: ({ row, column, route, action }) => (
      <PayPeriodTableMenu row={row} column={column} route={route} deleteAction={action} />
    ),
  },
];

const useColumns = () => {
  return [columns];
};

export default useColumns;
